export const MenuItems = [
    {
       title: 'Home',
       url: '/',
       cName: 'nav-links'
   },
    {
       title: 'Work Experience',
       url: '/about',
       cName: 'nav-links'
    },
   {
       title: 'Projects',
       url: '/work',
       cName: 'nav-links'
   },

    {
       title: 'My Blog',
       url: '/blog',
       cName: 'nav-links'
    },
     {
       title: 'Test Hub',
       url: '/test',
       cName: 'nav-links'
    }
]